import { Injectable } from '@angular/core';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Injectable({ providedIn: 'root' })
export class AnnouncerService {
  constructor(private readonly liveAnnouncer: LiveAnnouncer) {}

  announce(message: string, politeness: 'polite' | 'assertive' = 'polite'): void {
    if (!message) {
      return;
    }
    this.liveAnnouncer.announce(message, politeness);
  }

  announceAssertive(message: string): void {
    this.announce(message, 'assertive');
  }

  clear(): void {
    this.liveAnnouncer.clear();
  }
}
